<template>
  <gjw-dialog
    :title="$t('component.checkRenameTitle')"
    :show-dialog="dialogVisible"
    :config="{ width: '760px' }"
    @close="closeDialog">
    <div>
      <gjw-table
        ref="listTable"
        v-loading="tableLoading"
        :columns="tableColumns"
        :list-data="tableData"
        :has-page="false"
      >
        <template #renameLabelSlot>
          <el-checkbox v-model="allReName" @input="handleChange('reName')">{{ $t('component.checkRenameRenameAll') }}</el-checkbox>
        </template>
        <template #renameSlot="{ row }">
          <el-radio v-model="row.reName" :label="true" @input="handleInput(row, 'reName')">{{ $t('component.checkRenameRename') }}</el-radio>
        </template>
        <template #coverLabelSlot>
          <el-checkbox v-model="allCover" @input="handleChange('cover')">{{ $t('component.checkRenameCoverAll') }}</el-checkbox>
        </template>
        <template #coverSlot="{ row }">
          <el-radio v-model="row.cover" :label="true" @input="handleInput(row, 'cover')">{{ $t('component.checkRenameCover') }}</el-radio>
        </template>
        <template #noLoadLabelSlot>
          <el-checkbox v-model="allNoLoad" @input="handleChange('noLoad')">{{ $t('load.checkRenameDialogNoLoadAll') }}</el-checkbox>
        </template>
        <template #noLoadSlot="{ row }">
          <el-radio v-model="row.noLoad" :label="true" @input="handleInput(row, 'noLoad')">{{ $t('load.checkRenameDialogNoLoad') }}</el-radio>
        </template>
      </gjw-table>
    </div>
    <template #customFooter>
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </template>
  </gjw-dialog>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      allReName: false,
      allCover: true,
      allNoLoad: false,
      row: {},
      actionType: '',
      subdivideType: '',
      batchSelectData: []
    }
  },
  props: {
    dialogVisible: {
      type: Boolean
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    tableData: {
      handler(val) {
        this.allReName = val.every((item) => item.reName === true)
        this.allCover = val.every((item) => item.cover === true)
        this.allNoLoad = val.every((item) => item.noLoad === true)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tableColumns() {
      const allCols = [
        {
          label: this.$t('component.checkRenameComponent'),
          prop: 'familyName',
          minWidth: '140px',
        },
        {
          label: this.$t('component.checkRenameInstanceCount'),
          prop: 'instanceCount',
          minWidth: '60px',
        },
        {
          type: 'slot',
          slotName: 'renameSlot',
          labelSlotName: 'renameLabelSlot',
          prop: 'rename',
          minWidth: '80px'
        },
        {
          type: 'slot',
          slotName: 'coverSlot',
          labelSlotName: 'coverLabelSlot',
          prop: 'cover',
          minWidth: '80px'
        },
        {
          type: 'slot',
          slotName: 'noLoadSlot',
          labelSlotName: 'noLoadLabelSlot',
          prop: 'noLoad',
          minWidth: '80px'
        }
      ]
      return allCols.filter((col) => {
        return col.showFn ? col.showFn() : true
      })
    }
  },
  methods: {
    init(tableData, row, actionType, subdivideType, batchSelectData) {
      this.tableData = tableData.map((item) => ({
        ...item,
        reName: false,
        cover: true,
        noLoad: false,
      }))
      this.row = row
      this.actionType = actionType
      this.subdivideType = subdivideType
      this.batchSelectData = batchSelectData
    },
    handleChange(type) {
      switch (type) {
        case 'reName':
          this.allReName = true
          this.allCover = false
          this.allNoLoad = false
          this.tableData = this.tableData.map((item) => ({
            ...item,
            reName: true,
            cover: false,
            noLoad: false,
          }))
          break
        case 'cover':
          this.allReName = false
          this.allCover = true
          this.allNoLoad = false
          this.tableData = this.tableData.map((item) => ({
            ...item,
            reName: false,
            cover: true,
            noLoad: false,
          }))
          break
        case 'noLoad':
          this.allReName = false
          this.allCover = false
          this.allNoLoad = true
          this.tableData = this.tableData.map((item) => ({
            ...item,
            reName: false,
            cover: false,
            noLoad: true,
          }))
          break
      }
    },
    handleInput(row, type) {
      switch (type) {
        case 'reName':
          row.reName = true
          row.cover = false
          row.noLoad = false
          this.allReName = false
          this.allCover = false
          this.allNoLoad = false
          break
        case 'cover':
          row.reName = false
          row.cover = true
          row.noLoad = false
          this.allReName = false
          this.allCover = false
          this.allNoLoad = false
          break
        case 'noLoad':
          row.reName = false
          row.cover = false
          row.noLoad = true
          this.allReName = false
          this.allCover = false
          this.allNoLoad = false
          break
      }
    },
    replaceOrReplaceAll(result, selectedList, noLoadNameMap) {
      const selectedData = selectedList.filter((selItem) => !noLoadNameMap.includes(selItem.name))
      if (result.length === 0) {
        return selectedData
      }
      if (selectedList.length === 0) {
        return result
      }
      return selectedData.map((selItem) => {
        const selectedItem = result.find((item) => item.familyName === selItem.name)
        return selectedItem ? { ...selectedItem, ...selItem } : selItem
      })
    },
    handleConfirm() {
      const noLoadNameMap = this.tableData.filter((item) => item.noLoad).map((item) => item.familyName)
      const result = this.tableData.filter((item) => !item.noLoad)
      this.closeDialog()
      const list = this.replaceOrReplaceAll(result, this.selectedList, noLoadNameMap)
      if (!list.length) return
      this.$emit('confirm', list, this.row, this.actionType, this.subdivideType, this.batchSelectData)
    },
    closeDialog() {
      this.subdivideType = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .el-checkbox__label {
    font-size: 12px;
    font-weight: bold;
  }
</style>
